<template>
	<div class="order-msg-card">
		<div class="omc-head">
			<span class="omc-status">{{ order.status }}</span>
			<span class="omc-code">编码：{{ order.id }}</span>
		</div>
		<div class="omc-body">
			<img class="omc-img" :src="order.imgurl" alt="商品图" />
			<div class="omc-info">
				<div class="omc-title" :title="order.productName">{{ order.productName }}</div>
				<div class="omc-price">
					¥ {{ priceText }}
					<span class="omc-spec" v-if="order.size">规格：{{ order.size }}</span>
				</div>
			</div>
		</div>
		<div class="omc-recv">
			<div class="omc-row">收件人：{{ order.name }}　{{ order.phone }}</div>
			<div class="omc-row">地址：{{ order.address }}</div>
			<div class="omc-row" v-if="order.remark">备注：{{ order.remark }}</div>
		</div>
	</div>
</template>

<script>
// 聊天流中的订单卡片消息（抖店/京麦统一外观，无操作按钮）
// platform 预留区分平台，目前两端外观一致
export default {
	name: 'OrderMsgCard',
	props: {
		order: { type: Object, required: true },
		platform: { type: String, default: '' }
	},
	computed: {
		priceText() {
			const p = Number(this.order && this.order.price);
			return isFinite(p) ? p.toFixed(2) : ((this.order && this.order.price) || '');
		}
	}
}
</script>

<style scoped>
.order-msg-card {
	width: 360px;
	background: #fff;
	border: 1px solid #e6e6e6;
	border-radius: 8px;
	overflow: hidden;
	font-size: 13px;
	color: #333;
}
.omc-head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 10px;
	background: #f7f8fa;
	border-bottom: 1px solid #eee;
}
.omc-status { color: #fa5151; font-weight: 600; }
.omc-code { color: #999; font-size: 12px; }
.omc-body { display: flex; padding: 10px; }
.omc-img {
	width: 60px;
	height: 60px;
	border-radius: 4px;
	object-fit: cover;
	flex: 0 0 60px;
}
.omc-info { margin-left: 10px; min-width: 0; flex: 1; }
.omc-title {
	line-height: 18px;
	max-height: 36px;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.omc-price { margin-top: 6px; color: #fa5151; font-weight: 700; }
.omc-spec { color: #999; font-weight: 400; font-size: 12px; margin-left: 8px; }
.omc-recv { padding: 8px 10px; border-top: 1px solid #f0f0f0; line-height: 20px; }
.omc-row { color: #666; word-break: break-all; }
</style>



// WEBPACK FOOTER //
// ./src/page/train/FBT/components/OrderMsgCard.vue